<!--
 * @Description: 合同签名指引
 * @Date: 2023-07-19 11:57:37
-->
<template>
  <div v-if="boxShow">
    <div class="tip-box">
      <div @click="onCancel" class="tip-x">x</div>
      <div class="tip-openview" @click="dialogVisible = true">
        如何查看合同签名信息
      </div>
    </div>
    <el-dialog
      center
      title=""
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      top="7vh"
      width="1500px"
    >
      <img
        style="width: 100%;height: 100%;"
        src="//cdn.yxvzb.com/WEB/SaaS/images/mgmt/contract-guidelines.jpg"
        alt=""
      />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'contractSignatureView',
  data() {
    return {
      dialogVisible: false,
      boxShow: true
    };
  },
  methods: {
    onCancel() {
      this.boxShow = false;
      localStorage.setItem('contractSignatureViewShow', 1);
    }
  },
  created() {
    const contractSignatureViewShow =
      localStorage.getItem('contractSignatureViewShow') || false;
    this.boxShow = !contractSignatureViewShow;
  }
};
</script>
<style scoped lang="scss">
.tip-box {
  position: fixed;
  top: 30vh;
  right: -2px;
  z-index: 9;
}
.tip-openview {
  font-size: 13px;
  color: #fff;
  background: #1890ff;
  width: 18px;
  line-height: 1;
  padding: 6px 2px;
  border-radius: 2px;
  cursor: pointer;
}
.tip-x {
  color: #fff;
  cursor: pointer;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 17px;
  background: #535353;
  margin-bottom: 4px;
}
.tip-x:hover {
  background: #272727;
}
</style>
